// import { useEffect, useState } from "react";
// import {
//   allImagesPath,
//   allVideoPath,
// } from "../../../lib/constants/constantsData";

// const OrdersSection = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   useEffect(() => {
//   if (isMenuOpen) {
//     document.body.style.overflow = "hidden";
//   } else {
//     document.body.style.overflow = "";
//   }

//   return () => {
//     document.body.style.overflow = "";
//   };
// }, [isMenuOpen]);

//   return (
//     <div>
//       {/* START LEARNING SECTION */}
//       <section className="w-full px-4 pt-[45%] sm:pt-[35%] lg:pt-[30%] xl:pt-[20%] 2xl:pt-[15%]">
//         <div className="mx-auto max-w-6xl">
//           <div className="mb-8 text-center">
//             <h4 className="text-sm uppercase tracking-wide text-[#333333] md:text-base md:font-semibold">
//               Start Learning
//             </h4>
//             <h1 className="mt-2 font-heading text-3xl uppercase md:text-4xl lg:text-5xl">
//               Your Guide to Custom Orders
//             </h1>
//             <p className="mx-auto mb-10 mt-4 max-w-2xl py-2 text-base text-paragraph">
//               Learn how to order custom products in 3 easy steps.{" "}
//             </p>
//           </div>
//         </div>
//       </section>

//       <section className="relative h-[450px] w-full px-4 sm:h-[600px] md:h-[800px] lg:h-[1000px] xl:h-[1200px] 2xl:h-[1300px]">
//         <div className="absolute left-1/2 top-0 z-10 mx-auto mb-16 flex w-full max-w-6xl -translate-x-1/2 justify-center">
//           <div className="md:full relative w-[80%] lg:w-[80%] xl:w-full">
//             <video
//               className="aspect-video h-auto w-full rounded-md object-cover shadow-lg"
//               controls >
//               <source src={allVideoPath.orderGuideVideo} type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>{" "}
//             <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
//               <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg md:h-20 md:w-20">
//                 <div className="ml-1 h-0 w-0 border-b-[10px] border-l-[16px] border-t-[10px] border-b-transparent border-l-black border-t-transparent"></div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className=" absolute left-0 top-[20%] z-5 pb-[60px] w-full bg-featureProBg bg-cover bg-no-repeat">
//           <div className="mt-[31%] flex flex-col items-center md:mt-[30%] lg:mt-[32%] xl:mt-[26%] 2xl:mt-[20%] xl:gap-y-[100px]">
//             <div className="w-[80%] text-center mt-0 sm:mt-0 md:mt-[3%] lg:mt-[2%] xl:mt-[170px] 2xl:mt-[10]">
//               <h1 className="font-heading text-sm uppercase text-white sm:text-xl md:text-3xl lg:text-4xl xl:text-5xl">
//                 GET YOUR CUSTOM PRODUCT IN 3 SIMPLE STEPS
//               </h1>
//             </div>

//             <div className="mt-10 sm:mt-16 xl:mt-0">
//               <img
//                 src={allImagesPath.homevisual || "/placeholder.svg"}
//                 className="max-h-[120px] object-contain sm:max-h-[170px] md:max-h-[250px] lg:max-h-[300px] xl:max-h-[400px]"
//                 alt="Custom product steps"
//               />
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default OrdersSection;






import { useEffect, useState } from "react";
import {
  allImagesPath,
  allVideoPath,
} from "../../../lib/constants/constantsData";
import VideoPlayer from "@/components/VideoPlayer";

const OrdersSection = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <div>
      {/* START LEARNING SECTION */}
      <section className="w-full px-4 pt-20 h-[400px] sm:h-[450px] md:h-[500px] lg:h-[550px] xl:h-[600px] 2xl:h-[650px] flex items-center justify-center pb-20 sm:pb-24 md:pb-32">
        <div className="mx-auto max-w-6xl">
          <div className=" mb-14 xl:pt-20 lg:pt-48 md:pt-56 pt-52 text-center">
            <h4 className="text-xs uppercase font-sfPro tracking-wide text-[#333333] md:text-base md:font-semibold">
              Start Learning
            </h4>
            {/* <h1 className=" w-full text-white font-heading uppercase leading-tight md:text-[56px] text-2xl"></h1> */}
            <h1 className="text-black md:mt-2 font-heading uppercase leading-tight md:text-[56px] text-2xl">
              Your Guide to Custom Orders
            </h1>
            <p className="mx-auto mb-10 font-sfPro md:mt-4 mt-2 max-w-2xl py-2 text-base text-paragraph">
              Learn how to order custom enclosures.
            </p>
          </div>
        </div>
      </section>

      <section className="relative h-[450px] w-full px-4 sm:h-[600px] md:h-[800px] lg:h-[1000px] xl:h-[1200px] 2xl:h-[1300px]">
        <div className="absolute left-1/2 top-0 z-50 mx-auto mb-16 flex w-full max-w-6xl -translate-x-1/2 justify-center">
          <VideoPlayer
            videoSrc={allVideoPath.orderGuideVideo}
            className="w-[80%] lg:w-[80%] xl:w-full"
          />


        </div>

        <div className="absolute left-0 top-[20%] z-10 pb-[60px] w-full bg-featureProBg bg-cover bg-no-repeat">
          <div className="mt-[31%] flex flex-col items-center md:mt-[30%] lg:mt-[32%] xl:mt-[26%] 2xl:mt-[20%] xl:gap-y-[100px]">
            <div className="w-[80%] text-center mt-0 sm:mt-0 md:mt-[3%] lg:mt-[2%] xl:mt-[170px] 2xl:mt-[10]">
              <h1 className=" w-full text-white font-heading uppercase leading-tight md:text-4xl lg:text-5xl text-2xl">
                {/* GET YOUR CUSTOM ENCLOSUREs IN 2 WAYS */}
                ORDER CUSTOM ENCLOSURES IN 2 WAYS
              </h1>
            </div>

            <div className="mt-8 sm:mt-16 xl:mt-0 w-[90%] flex justify-center item-center">
              <img
                src={allImagesPath.homevisual || "/placeholder.svg"}
                className="max-h-[120px] object-contain sm:max-h-[170px] md:max-h-[200px] lg:max-h-[250px] xl:max-h-[300px]"
                alt="Custom product steps"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrdersSection;
